export const loading = "remote.loading";
